import { render } from "./QuestionManager.vue?vue&type=template&id=4fda27d1"
import script from "./QuestionManager.vue?vue&type=script&lang=js"
export * from "./QuestionManager.vue?vue&type=script&lang=js"

import "./QuestionManager.vue?vue&type=style&index=0&id=4fda27d1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__